import { Injectable } from "@angular/core";

import { BehaviorSubject, Observable } from "rxjs";

import { ApiResponseData } from "#interfaces/http-response/responses/http-responses";
import { HttpErrorResponse } from "@angular/common/http";
import { FuseAlertService } from "@fuse/components/alert";

@Injectable({
  providedIn: "root",
})
export class AlertService {
  private _message: BehaviorSubject<{ message: string; errors: Array<string> | null } | null> = new BehaviorSubject(null);
  private _updateMessage: BehaviorSubject<string | null> = new BehaviorSubject(null);
  private _saveMessage: BehaviorSubject<string | null> = new BehaviorSubject(null);
  private _warningMessage: BehaviorSubject<string | null> = new BehaviorSubject(null);
  private isNotSent: boolean = true;

  constructor(private readonly alertService: FuseAlertService) {}

  get message$(): Observable<{ message: string; errors: Array<string> | null }> {
    return this._message.asObservable();
  }

  get updateMessage$(): Observable<string> {
    return this._updateMessage.asObservable();
  }

  get saveMessage$(): Observable<string> {
    return this._saveMessage.asObservable();
  }

  get warningMessage$(): Observable<string> {
    return this._warningMessage.asObservable();
  }

  async updateAlert(message: string) {
    this._updateMessage.next(message);
    this.alertService.show("update-alert");
    await new Promise((resolve) => {
      setTimeout(() => {
        resolve(this.alertService.dismiss("update-alert"));
      }, 5000);
    });
  }

  async saveAlert(message: string) {
    this._saveMessage.next(message);
    this.alertService.show("save-alert");
    await new Promise((resolve) => {
      setTimeout(() => {
        resolve(this.alertService.dismiss("save-alert"));
      }, 5000);
    });
  }

  async warningAlert(message: string) {
    this._warningMessage.next(message);
    this.alertService.show("warning-alert");
    await new Promise((resolve) => {
      setTimeout(() => {
        resolve(this.alertService.dismiss("warning-alert"));
      }, 6000);
    });
  }

  async errorAlert(errorArray: Array<string> | null, message: string) {
    if (this.isNotSent) {
      this._message.next({ message: message, errors: errorArray });
      this.isNotSent = false;
      this.alertService.show("error-alert");
      await new Promise((resolve) => {
        setTimeout(() => {
          this.isNotSent = true;
          resolve(this.alertService.dismiss("error-alert"));
        }, 5000);
      });
    } else {
      return;
    }
  }

  handleAlertResponse(response: HttpErrorResponse | ApiResponseData<any> | { message: string }) {
    if (response instanceof HttpErrorResponse) {
      const errorsObject = response?.error?.errors;

      if (errorsObject) {
        const errorsList = Object.values(errorsObject);
        const listFlattened: string[] = errorsList.flat() as string[];
        this.errorAlert(listFlattened, response?.error?.message ?? response?.error?.Message ?? response?.error?.title ?? response?.error?.title);
        return;
      }
      this.errorAlert(
        response?.error?.errors ?? response?.error?.Errors,
        response?.error?.message ?? response?.error?.Message ?? response?.error?.title ?? response?.error?.title
      );
    } else {
      this.saveAlert(response?.message);
    }
  }
}
